import actions from './actions'
import mutations from './mutations'
import { dropdowns } from './constants'

export default {
  namespaced: true,
  state() {
    return Object.keys(dropdowns).reduce((acc, key) => {
      acc[dropdowns[key]] = {
        expanded: false,
      }

      return acc
    }, {})
  },
  actions,
  mutations,
}
